// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608260849/js/" + chunkId + "." + {"44":"6bb6b1d1","225":"fc7e9ea8","481":"8578cbf9","486":"274752df","770":"06869f17"}[chunkId] + ".0.4604289415490359.chunk.js";
};